/**
 * Paylaşılan bilgi bandı (013 tasarım dili — Figma). Açık mavi zemin + kenar, sol beyaz kutuda
 * uyarı ikonu, başlık + opsiyonel açıklama, sağda kapat (×). Kapatılabilir (onClose verilirse).
 * Renkler token'lardan (--info-* / uyarıda --open* amber). Tüm ekranlar bunu yeniden kullanır (Reuse Mandate).
 */
export interface InfoBannerProps {
  title: string
  description?: string
  /** primeicons sınıfı (varsayılan uyarı üçgeni). */
  icon?: string
  /** Ton: `info` (mavi, varsayılan) veya `warn` (amber uyarı). */
  tone?: 'info' | 'warn'
  /** Verilirse kapat (×) butonu gösterilir. */
  onClose?: () => void
  closeLabel?: string
}

export default function InfoBanner({
  title,
  description,
  icon = 'pi pi-exclamation-triangle',
  tone = 'info',
  onClose,
  closeLabel = 'Kapat',
}: Readonly<InfoBannerProps>) {
  return (
    <div className={`ui-banner${tone === 'warn' ? ' ui-banner--warn' : ''}`} role="status">
      <span className="ui-banner-icon">
        <i className={icon} aria-hidden />
      </span>
      <div className="ui-banner-text">
        <div className="ui-banner-title">{title}</div>
        {description && <div className="ui-banner-desc">{description}</div>}
      </div>
      {onClose && (
        <button type="button" className="ui-banner-close" aria-label={closeLabel} onClick={onClose}>
          <i className="pi pi-times" aria-hidden />
        </button>
      )}
    </div>
  )
}
